import { Button, Modal, Toast } from '@seiue/ui'
import { useContext } from 'react'
import styled from 'styled-components'

import { pluginApi } from 'packages/sdks-next/growp'

import { TagContextParam } from '../../utils/type'
import { TagContext, allTagName } from '../../utils/util'

/**
 * 分类管理 - 尾部内容
 *
 * @returns 组件
 */
export const TagDrawerFooter: React.FC = () => {
  const {
    current,
    setCurrent,
    setVisible,
    showTag,
    dragTags,
    dragSchoolPlugins,
  } = useContext<TagContextParam>(TagContext)

  const { api: delPluginTag } = pluginApi.useDeleteSchoolPluginTag({
    reload: [pluginApi.querySchoolPluginTags, pluginApi.querySchoolPlugins],
  })

  const { api: sortPluginTag } = pluginApi.useBatchSortSchoolPluginTag({
    reload: [pluginApi.querySchoolPluginTags],
  })

  const { api: sortPlugin } = pluginApi.useBatchSortSchoolPlugin({
    reload: [pluginApi.querySchoolPlugins],
  })

  const hiddenDel = current === 0 || showTag?.isVirtual === true

  return (
    <Box>
      {hiddenDel ? (
        <ItemSpace />
      ) : (
        <Button
          type="danger"
          onClick={async () => {
            if (showTag === undefined) return

            Modal.danger({
              title: '确认删除该分类吗?',
              content:
                '正在删除该分类，删除后该分类的应用被归类到未分类应用，确认删除吗？',
              onOk: async () => {
                await delPluginTag(showTag.id)
                Toast.success('已删除分类')
                setCurrent(0)
              },
            })
          }}
        >
          {'删除分类'}
        </Button>
      )}
      <RightBtn>
        <Button
          type="gray"
          onClick={() => (current === 0 ? setVisible(false) : setCurrent(0))}
          style={{ marginRight: '12px' }}
        >
          {'取消'}
        </Button>
        <Button
          type="primary"
          style={{ marginRight: 0 }}
          onClick={async () => {
            if (current === 0) {
              const data = dragTags.map((e) => {
                return {
                  id: e.id,
                  weight: e.weight || 0,
                }
              })

              await sortPluginTag(data)
            } else if (dragSchoolPlugins.length === 0) {
              return
            } else if (showTag?.name !== allTagName) {
              const data = dragSchoolPlugins.map((e) => {
                return {
                  id: e.id,
                  groupWeight: e.groupWeight,
                }
              })

              await sortPlugin({ payload: data, query: { isGroupSort: true } })
            } else {
              const data = dragSchoolPlugins.map((e) => {
                return {
                  id: e.id,
                  weight: e.weight,
                }
              })

              await sortPlugin({ payload: data, query: { isGroupSort: false } })
            }

            Toast.success('保存成功')
          }}
        >
          {'保存'}
        </Button>
      </RightBtn>
    </Box>
  )
}

const Box = styled.div`
  height: 64px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
`

const RightBtn = styled.div``

const ItemSpace = styled.div`
  width: 16px;
  height: 16px;
`
